import { render, staticRenderFns } from "./member-add.vue?vue&type=template&id=72f8e582&scoped=true"
import script from "./member-add.vue?vue&type=script&lang=js"
export * from "./member-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8e582",
  null
  
)

export default component.exports